import { useCallback, useEffect, useState } from 'react';

const useLoading = (haveSomeData, timeout = 2000) => {
    const [timedOut, setTimedOut] = useState(false);

    useEffect(() => {
        if (!haveSomeData && !timedOut) {
            const timer = setTimeout(() => {
                setTimedOut(true);
            }, timeout);
            return () => clearTimeout(timer);
        }
    }, [haveSomeData, timedOut, timeout]);

    const reset = useCallback(() => setTimedOut(false), []);

    return [!haveSomeData && !timedOut, reset];
};

export default useLoading;
